import { Checkbox, FormControlLabel, FormGroup } from "@mui/material";
import { ContactUsage } from "@repo/server-api";
import { ContactExtended } from "@repo/server-api/types";
import { useTranslation } from "next-i18next";

export default function DialogActions(
	props: Readonly<{
		contact: ContactExtended | null;
		setContact: (value: ContactExtended | null) => void;
	}>,
) {
	const { t } = useTranslation();

	return (
		<div>
			<FormGroup>
				<FormControlLabel
					control={
						<Checkbox
							value={ContactUsage.Invoice}
							checked={
								props.contact?.contactUsage?.includes(ContactUsage.Invoice) ??
								false
							}
							onChange={(event) => {
								const contactUsage = [
									...(props.contact?.contactUsage?.filter(
										(value) => value !== ContactUsage.Invoice,
									) || []),
									event.target.checked ? ContactUsage.Invoice : undefined,
								].filter((value) => value !== undefined);
								props.setContact({
									...props.contact,
									contactUsage,
								});
							}}
						/>
					}
					label={t("email-configuration.send-invoice")}
				/>
				<FormControlLabel
					control={
						<Checkbox
							value={ContactUsage.InvoiceReminder}
							checked={
								props.contact?.contactUsage?.includes(
									ContactUsage.InvoiceReminder,
								) ?? false
							}
							onChange={(event) => {
								const contactUsage = [
									...(props.contact?.contactUsage?.filter(
										(value) => value !== ContactUsage.InvoiceReminder,
									) || []),
									event.target.checked
										? ContactUsage.InvoiceReminder
										: undefined,
								].filter((value) => value !== undefined);
								props.setContact({
									...props.contact,
									contactUsage,
								});
							}}
						/>
					}
					label={t("email-configuration.send-reminder")}
				/>
				<FormControlLabel
					control={
						<Checkbox
							value={ContactUsage.Offer}
							checked={
								props.contact?.contactUsage?.includes(ContactUsage.Offer) ??
								false
							}
							onChange={(event) => {
								const contactUsage = [
									...(props.contact?.contactUsage?.filter(
										(value) => value !== ContactUsage.Offer,
									) || []),
									event.target.checked ? ContactUsage.Offer : undefined,
								].filter((value) => value !== undefined);
								props.setContact({
									...props.contact,
									contactUsage,
								});
							}}
						/>
					}
					label={t("email-configuration.send-offer")}
				/>
			</FormGroup>
		</div>
	);
}
